import { useEffect } from 'react';

function SignupRedirect() {
  useEffect(() => {
    // Construct the Cognito signup URL
    const signupUrl = new URL(`https://${process.env.REACT_APP_COGNITO_OAUTH_DOMAIN}/signup`);
    signupUrl.searchParams.append('client_id', process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID);
    signupUrl.searchParams.append('response_type', 'code');
    signupUrl.searchParams.append('redirect_uri', process.env.REACT_APP_COGNITO_REDIRECT_URI);

    // Add a state parameter to track that user came from signup
    // This will be returned after authentication
    signupUrl.searchParams.append('state', 'new_signup');

    // Redirect to Cognito signup page
    window.location.href = signupUrl.toString();
  }, []);

  // Show a loading message while redirecting
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontSize: '18px'
    }}>
      Redirecting to sign up...
    </div>
  );
}

export default SignupRedirect;